var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultGirlAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    width: 84,
    height: 84,
    transform: "translate(-208 1043)",
    fill: "#f2f4f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(208 -1043)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2987",
    "data-name": "Rectangle 2987",
    width: 84,
    height: 84,
    transform: "translate(-208 1043)",
    fill: "#f2f4f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3198",
    "data-name": "Group 3198",
    transform: "translate(173 186.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_670",
    "data-name": "Ellipse 670",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(-381 856.5)",
    fill: "#f2f4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M-397,688.444s-4.553,7.55-3.958,19.311c.2,4.044,2.033,10.254,5.258,17a28.214,28.214,0,0,0,7.643,10l24.092,2.357,17.65-6.137a2.612,2.612,0,0,1-1.182-2.039,12.646,12.646,0,0,1,.64-3.2,8.193,8.193,0,0,0,1.532,3.625A4.464,4.464,0,0,0-342.3,730.5a3.233,3.233,0,0,1,0-3.9c2.041-3.406,5.046-8.817,1.959-14.845-4.537-8.859-6.322-16.39-6.513-20.333-.383-7.933-15.964-12.32-15.964-12.32L-393.8,683.49Z",
    transform: "translate(31 195)",
    fill: "#919aaa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2498",
    "data-name": "Path 2498",
    transform: "translate(-365 913)",
    fill: "#ccd6e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 39.96783828735352 C 22.36212921142578 39.96783828735352 19.03504943847656 39.73622894287109 16.11116027832031 39.27943801879883 C 13.02680969238281 38.79757690429688 10.3760404586792 38.06253814697266 8.23246955871582 37.0947265625 C 6.032859802246094 36.10160827636719 4.35207986831665 34.85508728027344 3.236809968948364 33.38978576660156 C 2.06810998916626 31.85429763793945 1.5 30.09127807617188 1.5 27.99999809265137 C 1.5 25.73466682434082 2.16510009765625 22.97472763061523 3.423379898071289 20.01855659484863 C 4.729050159454346 16.95107650756836 6.5802001953125 13.90902709960938 8.776700019836426 11.22126770019531 C 11.14515018463135 8.323126792907715 13.86625957489014 5.918227195739746 16.6458797454834 4.266547203063965 C 19.73526954650879 2.430797338485718 22.88245010375977 1.49999725818634 26 1.49999725818634 C 29.11754989624023 1.49999725818634 32.26472854614258 2.430797338485718 35.35411834716797 4.266547203063965 C 38.13373947143555 5.918227195739746 40.85485076904297 8.323126792907715 43.22330093383789 11.22126770019531 C 45.4197998046875 13.90902709960938 47.27095031738281 16.95107650756836 48.57661819458008 20.01855659484863 C 49.83489990234375 22.97472763061523 50.5 25.73466682434082 50.5 27.99999809265137 C 50.5 30.09127807617188 49.93188858032227 31.85429763793945 48.76319122314453 33.38978576660156 C 47.64791870117188 34.85508728027344 45.96714019775391 36.10160827636719 43.76752853393555 37.0947265625 C 41.62395858764648 38.06253814697266 38.97319030761719 38.79757690429688 35.88883972167969 39.27943801879883 C 32.96495056152344 39.73622894287109 29.63787078857422 39.96783828735352 26 39.96783828735352 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26 2.999996185302734 C 23.15584945678711 2.999996185302734 20.26646995544434 3.8599853515625 17.4121208190918 5.556068420410156 C 14.78144073486328 7.119247436523438 12.19699859619141 9.406467437744141 9.938179016113281 12.17046737670898 C 7.830051422119141 14.75007629394531 6.054531097412109 17.66704750061035 4.803558349609375 20.60602760314941 C 3.640518188476562 23.33842658996582 3 25.96432685852051 3 27.99999618530273 C 3 29.75085830688477 3.467891693115234 31.21670722961426 4.430408477783203 32.48131561279297 C 5.393001556396484 33.74601745605469 6.879871368408203 34.83822631835938 8.849720001220703 35.72760772705078 C 12.82024002075195 37.52027893066406 18.75070953369141 38.46783828735352 26 38.46783828735352 C 33.24929046630859 38.46783828735352 39.17975997924805 37.52027893066406 43.1502799987793 35.72760772705078 C 45.1201286315918 34.83822631835938 46.60699844360352 33.74601745605469 47.5695915222168 32.48131561279297 C 48.53210830688477 31.21670722961426 49 29.75085830688477 49 27.99999618530273 C 49 25.96432685852051 48.35948181152344 23.33842658996582 47.19644165039062 20.60602760314941 C 45.94546890258789 17.66704750061035 44.16994857788086 14.75007629394531 42.06182098388672 12.17046737670898 C 39.80300140380859 9.406467437744141 37.21855926513672 7.119247436523438 34.5878791809082 5.556068420410156 C 31.73353004455566 3.8599853515625 28.84415054321289 2.999996185302734 26 2.999996185302734 M 26 -3.814697265625e-06 C 40.35939788818359 -3.814697265625e-06 52 18.05887794494629 52 27.99999618530273 C 52 37.94112777709961 40.35939788818359 41.46783828735352 26 41.46783828735352 C 11.64059829711914 41.46783828735352 0 37.94112777709961 0 27.99999618530273 C 0 18.05887794494629 11.64059829711914 -3.814697265625e-06 26 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#919aaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2501",
    "data-name": "Path 2501",
    transform: "translate(-366 875)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 44.5 C 18.70742034912109 44.5 12.64208030700684 42.99409103393555 8.459699630737305 40.14506912231445 C 3.841579914093018 36.99922943115234 1.5 32.24013900756836 1.5 26 C 1.5 22.69186019897461 2.147569894790649 19.48347091674805 3.424720048904419 16.46396064758301 C 4.658609867095947 13.54668998718262 6.425360202789307 10.92640972137451 8.67588996887207 8.67588996887207 C 10.92640972137451 6.425360202789307 13.54668998718262 4.658609867095947 16.46396064758301 3.424720048904419 C 19.48347091674805 2.147569894790649 22.69186019897461 1.5 26 1.5 C 29.30813980102539 1.5 32.51652908325195 2.147569894790649 35.53604125976562 3.424720048904419 C 38.45330810546875 4.658609867095947 41.07358932495117 6.425360202789307 43.3241081237793 8.67588996887207 C 45.57463836669922 10.92640972137451 47.34138870239258 13.54668998718262 48.57527923583984 16.46396064758301 C 49.8524284362793 19.48347091674805 50.5 22.69186019897461 50.5 26 C 50.5 32.24013900756836 48.15842056274414 36.99922943115234 43.54029846191406 40.14506912231445 C 39.3579216003418 42.99409103393555 33.29257965087891 44.5 26 44.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26 3 C 22.89369964599609 3 19.88190841674805 3.607700347900391 17.04827880859375 4.806221008300781 C 14.30981826782227 5.964500427246094 11.84978866577148 7.623298645019531 9.736549377441406 9.736549377441406 C 7.623298645019531 11.84978866577148 5.964500427246094 14.3098201751709 4.806221008300781 17.04828071594238 C 3.607700347900391 19.88191032409668 3 22.89369964599609 3 26 C 3 28.98394966125488 3.574939727783203 31.61043930053711 4.708850860595703 33.80651092529297 C 5.749229431152344 35.82144165039062 7.295318603515625 37.53694915771484 9.304180145263672 38.90536880493164 C 13.23656845092773 41.58409881591797 19.00989151000977 43 26 43 C 32.9901123046875 43 38.763427734375 41.58409881591797 42.69581985473633 38.90536880493164 C 44.70468139648438 37.53694915771484 46.25077056884766 35.82144165039062 47.2911491394043 33.80651092529297 C 48.4250602722168 31.61043930053711 49 28.98394966125488 49 26 C 49 22.89369964599609 48.39229965209961 19.88191032409668 47.19377899169922 17.04828071594238 C 46.03549957275391 14.3098201751709 44.37670135498047 11.84978866577148 42.26345062255859 9.736549377441406 C 40.15021133422852 7.623298645019531 37.69017791748047 5.964500427246094 34.95172119140625 4.806221008300781 C 32.11808776855469 3.607700347900391 29.10630035400391 3 26 3 M 26 0 C 40.35939788818359 0 52 11.64059829711914 52 26 C 52 40.35939788818359 40.35939788818359 46 26 46 C 11.64059829711914 46 0 40.35939788818359 0 26 C 0 11.64059829711914 11.64059829711914 0 26 0 Z",
    stroke: "none",
    fill: "#919aaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_676",
    "data-name": "Ellipse 676",
    transform: "translate(-350 892)",
    fill: "#919aaa",
    stroke: "#919aaa",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_675",
    "data-name": "Ellipse 675",
    transform: "translate(-335 892)",
    fill: "#919aaa",
    stroke: "#919aaa",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M-384.374,614.263s1.632,2.416,6.087,2.416,6.221-2.416,6.221-2.416",
    transform: "translate(38.169 290.407)",
    fill: "none",
    stroke: "#919aaa",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M-397,693.05s28.308,1.076,40.023-1.355c1.445-8.064,0-6.292,0-6.292s2.9,5.885,4.3,6.292,11.011,0,11.011,0-2.832-23.134-27.452-21.6S-397,693.05-397,693.05",
    transform: "translate(28.214 198)",
    fill: "#919aaa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultGirlAvatar);
export default __webpack_public_path__ + "static/media/default_girl_avatar.26f6316d5c893c07fd7ad970bfb1803a.svg";
export { ForwardRef as ReactComponent };